import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Actions_Wind from "~/Actions_Wind";
import Actions_Wind_V2 from "~/Actions_Wind_V2";
import permission from "~/skills/permission";
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Typography, TablePagination, Link, Grid, makeStyles, Select, MenuItem, InputLabel, FormControl } from "@material-ui/core";
import EventNotificationPureViewDialog from "./dialogs/EventNotificationPureViewDialog";

const useStyles = makeStyles((theme) => ({
    searchButton: {
        backgroundColor: "#5597b4",
        color: "#fff",
        borderRadius: "6px",
        "&:hover": {
            backgroundColor: "#3E8CCB",
        },
    },
    addButton: {
        backgroundColor: "#fff",
        color: "#5597b4",
        border: "1px solid #5597b4",
        borderRadius: "6px",
        "&:hover": {
            backgroundColor: "#E6F2FB",
        },
    },
    editButton: {
        backgroundColor: "#fff",
        color: "#5597b4",
        border: "1px solid #5597b4",
        borderRadius: "6px",
        "&:hover": {
            backgroundColor: "#E6F2FB",
        },
    },
    viewButton: {
        backgroundColor: "#5597b4",
        color: "#fff",
        borderRadius: "4px",
        "&:hover": {
            backgroundColor: "#3E8CCB",
        },
    },
    deleteButton: {
        backgroundColor: "#999",
        color: "#fff",
        borderRadius: "4px",
        "&:hover": {
            backgroundColor: "#777",
        },
    },
    downloadButton: {
        backgroundColor: "#74d6d4",
        color: "#fff",
        borderRadius: "4px",
        "&:hover": {
            backgroundColor: "#0ABAB5",
        },
    },
    headerRow: {
        backgroundColor: "#f7f7f7",
    },
    oddRow: {
        backgroundColor: "#E6F7FB",
    },
    formControl: {
        minWidth: 120,
    }
}));

const statusOptions = [
    { value: "2", label: "全部" },
    { value: "1", label: "已執行" },
    { value: "0", label: "待處理" },
];

function EventReminder(props) {
    const { getEventNotificationsForGis } = props;
    const classes = useStyles();
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("2");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [viewDialogOpen, setViewDialogOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const addBtnRef = useRef(null);

    const handleStatusChange = (event) => {
        setStatusFilter(event.target.value);
    };

    const handleSearch = async (resetPage = false) => { 
        try {
            const currentPage = resetPage ? 1 : page + 1;

            const body = {
                keyword: search,
                page_index: currentPage,
                page_size: rowsPerPage,
                status: statusFilter,
            };

            const result = await getEventNotificationsForGis(body);
            // console.log(result);

            if (result?.data?.list) {
                const docs = result.data.list.map((item, idx) => ({
                    id: item.id,
                    serial: (currentPage - 1) * rowsPerPage + idx + 1,
                    add_user: item.add_user || "-",
                    deadline_date: item.deadline_date || "-",
                    event_content: item.event_content || "-",
                    event_name: item.event_name || "-",
                    emails: item.emails || "-",
                    notes: item.notes || "-",
                    notification_date: item.notification_date || "-",
                    notification_time: item.notification_time || "-",
                    status: item.status || "-",
                    upd_time: item.upd_time || "-",
                    windcontract_id: item.windcontract_id || "-",
                    windcontract_name: item.windcontract_name || "-",
                }));

                setRows(docs);
                setTotalCount(result.data.pagination_info.total || 0);
            }
        } catch (error) {
            console.error("Error fetching documents:", error);
        }
    };
    
    useEffect(() => {
        handleSearch();
    }, [page, rowsPerPage]);

    useEffect(() => {
        setPage(0);
        handleSearch(true);
    }, [search, statusFilter]);

    const handleView = (id) => {
        setSelectedId(id);
        setViewDialogOpen(true);
    };

    // 分頁控制
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    return (
        <Box
            p={3}
            display="flex"
            flexDirection="column"
            style={{
                overflowY: "auto",
            }}
        >
            <Typography
                variant="h6"
                gutterBottom
                style={{ fontWeight: "bold", textAlign: "left", marginRight: "auto" }}
            >
                事件提醒管理
            </Typography>

            {/* 搜尋 */}
            <Grid container spacing={2} alignItems="center" style={{ marginBottom: 16 }}>
                {/* 狀態選單 */}
                <Grid item>
                    <FormControl variant="outlined" size="small" className={classes.formControl}>
                        <InputLabel id="status-select-label">狀態</InputLabel>
                        <Select
                            labelId="status-select-label"
                            value={statusFilter}
                            onChange={handleStatusChange}
                            label="狀態"
                        >
                            {statusOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                {/* 關鍵字輸入框 */}
                <Grid item>
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="請輸入關鍵字"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        label="關鍵字"
                    />
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        className={classes.searchButton}
                        onClick={() => {
                            setPage(0); // 搜尋時重設 page
                            handleSearch(true);
                        }}
                    >
                        查詢
                    </Button>
                </Grid>
            </Grid>

            

            {/* 表格 */}
            <TableContainer component={Paper} style={{ maxHeight: "60vh", overflowY: "auto" }}>
                <Table>
                    <TableHead>
                        <TableRow className={classes.headerRow}>
                            <TableCell>序號</TableCell>
                            <TableCell>風場專案名稱</TableCell>
                            <TableCell>事件名稱</TableCell>
                            <TableCell>提醒日期時間</TableCell>
                            <TableCell>截止到期日期</TableCell>
                            <TableCell>狀態</TableCell>
                            <TableCell style={{ textAlign: "center" }}>功能</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, idx) => (
                            <TableRow
                                key={row.id}
                                className={idx % 2 === 0 ? classes.oddRow : ""}
                            >
                                <TableCell>{row.serial}</TableCell>
                                <TableCell>{row.windcontract_name}</TableCell>
                                <TableCell>{row.event_name}</TableCell>
                                <TableCell>
                                    <div>{row.notification_date ? row.notification_date.replace('T', ' ').split(' ')[0] : ''}</div>
                                    <div>{row.notification_time ? row.notification_time : ''}</div>
                                </TableCell>
                                <TableCell>
                                    {row.deadline_date ? row.deadline_date.replace('T', ' ').split(' ')[0] : ''}
                                </TableCell>
                                <TableCell>{String(row.status) === "0" ? "待處理" : String(row.status) === "1" ? "已執行" : row.status}</TableCell>
                                <TableCell>
                                    <Box display="flex" gridGap={8}>
                                        <Button size="small" className={classes.viewButton} onClick={() => handleView(row.id)}>
                                            檢視
                                        </Button>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                {/* 分頁 */}
                <TablePagination
                    component="div"
                    count={totalCount}
                    page={page}
                    onChangePage={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    labelRowsPerPage="每頁筆數"
                    labelDisplayedRows={({ from, to, count }) =>
                        `第 ${from}-${to} 筆，共 ${count} 筆`
                    }
                />
            </TableContainer>

            {/* 檢視 Dialog */}
            {
                viewDialogOpen && (
                    <EventNotificationPureViewDialog
                        open={viewDialogOpen}
                        onClose={() => setViewDialogOpen(false)}
                        eventId={selectedId}
                        getEventNotification={Actions_Wind_V2.getAnEventNotification}
                    />
                )
            }
        </Box>
    );
}

const mapStateToProps = (state) => ({
    sign: state.data?.AtyFunction,
    ProjectProgressList: state.data?.ProjectProgressList || {},
    ...permission.returnPermission(state),
});

const mapDispatchToProps = (dispatch) => ({
    getProjectProgressList: (body) => Actions_Wind.getProjectProgressList(dispatch, body),
    deleteProjectProgress: (id) => Actions_Wind.deleteProjectProgress(dispatch, { id }),
    getEventNotificationsForGis: (body) => Actions_Wind_V2.getEventNotificationsForGis(body),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventReminder);
